import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d734734")

_pushScopeId("data-v-3d734734")
const _hoisted_1 = { class: "date-group" }
const _hoisted_2 = { class: "date-container" }
const _hoisted_3 = { for: "start-date" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Start Date ")
const _hoisted_5 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_6 = { class: "date-container" }
const _hoisted_7 = { for: "end-date" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" End Date ")
const _hoisted_9 = {
  key: 0,
  class: "asterisk"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, [
      _createVNode("label", _hoisted_3, [
        _hoisted_4,
        (_ctx.startDateRequired ? true : false)
          ? (_openBlock(), _createBlock("span", _hoisted_5, "*"))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createVNode("input", {
        type: "date",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDateChange && _ctx.startDateChange(...args))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDateInternal = $event)),
        id: "start-date",
        required: _ctx.startDateRequired ? true : false
      }, null, 40, ["required"]), [
        [_vModelText, _ctx.startDateInternal]
      ])
    ]),
    _createVNode("span", _hoisted_6, [
      _createVNode("label", _hoisted_7, [
        _hoisted_8,
        (_ctx.endDateRequired ? true : false)
          ? (_openBlock(), _createBlock("span", _hoisted_9, "*"))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createVNode("input", {
        type: "date",
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endDateChange && _ctx.endDateChange(...args))),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.endDateInternal = $event)),
        id: "end-date",
        required: _ctx.endDateRequired ? true : false,
        min: _ctx.startDateInternal
      }, null, 40, ["required", "min"]), [
        [_vModelText, _ctx.endDateInternal]
      ])
    ])
  ]))
})